import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

export default function LoginPage() {
  const { login } = useAuth();
  const { theme, toggle } = useTheme();
  const navigate  = useNavigate();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', position: 'relative' }}>
      {/* Theme toggle in top-right corner */}
      <button
        onClick={toggle}
        title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        style={{
          position: 'absolute', top: 16, right: 16,
          background: 'var(--surface2)', border: '1px solid var(--border)',
          color: 'var(--text)', borderRadius: 8, padding: '6px 10px',
          cursor: 'pointer', fontSize: 13,
        }}>
        {theme === 'dark' ? '☀️' : '🌙'}
      </button>

      <div style={{ width: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            background: 'var(--logo-bg)', borderRadius: 14, padding: '24px 28px',
            display: 'inline-block', boxShadow: `0 8px 32px var(--shadow-strong)`,
          }}>
            <img src="/btechdata.jpeg" alt="Btechdata"
              style={{ display: 'block', maxWidth: 260, width: '100%', height: 'auto',
                       mixBlendMode: theme === 'light' ? 'multiply' : 'normal' }} />
          </div>
          <p style={{ fontSize: 11, color: 'var(--muted)', marginTop: 14, letterSpacing: '0.08em' }}>
            Republic of Georgia Healthcare Research Data Catalog
          </p>
        </div>
        <div className="card">
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: 14, fontWeight: 700, marginBottom: 20, letterSpacing: '0.05em' }}>
            Sign In
          </h2>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label style={{ fontSize: 10, color: 'var(--muted)', display: 'block', marginBottom: 5, letterSpacing: '0.06em' }}>EMAIL</label>
              <input className="input" type="email" placeholder="you@example.com"
                value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            </div>
            <div>
              <label style={{ fontSize: 10, color: 'var(--muted)', display: 'block', marginBottom: 5, letterSpacing: '0.06em' }}>PASSWORD</label>
              <input className="input" type="password" placeholder="••••••••"
                value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            {error && <div className="error-msg">{error}</div>}
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: 4, justifyContent: 'center' }}>
              {loading ? 'Signing in…' : 'Sign In →'}
            </button>
          </form>
        </div>
        <p style={{ textAlign: 'center', fontSize: 10, color: 'var(--muted)', marginTop: 16, letterSpacing: '0.04em' }}>
          Republic of Georgia Healthcare Data Discovery Portal
        </p>
      </div>
    </div>
  );
}
